import { environment } from "../../../environments/environment";
import { ChartSelectionCard } from "../Interfaces/chart-selection-card";
import { AppConstants } from "./app-constants";

export class PieChartConstants {
  pieChartImgFolderPath: string = "../../../assets/Images/PieChart/";
  /*baseUrl: string = environment.baseUrl;*/
  pieModuleRoutePath = AppConstants.pieCategoryPathMap.chartModuleRoutePath + "/";
  chartDescriptions: any = this.getChartDescriptions();
  pieChartModuleComponentPath: string = AppConstants.pieCategoryPathMap.moduleFolderPath;


  pieChartTypes: ChartSelectionCard[] = [
    // {
    //   "imgUrl": this.pieChartImgFolderPath + "01piechart.png",
    //   routePath: this.pieModuleRoutePath + "PieChart1",
    //   description: this.chartDescriptions.genericpieChartDescription,
    //   chartFolderPath: this.pieChartModuleComponentPath + "pie-chart1"
    // },
    // {
    //   "imgUrl": this.pieChartImgFolderPath + "02piechart.png",
    //   routePath: this.pieModuleRoutePath + "PieChart2",
    //   description: this.chartDescriptions.genericpieChartDescription,
    //   chartFolderPath: this.pieChartModuleComponentPath + "pie-chart2"
    // },
    // {
    //   "imgUrl": this.pieChartImgFolderPath + "03piechart.png",
    //   routePath: this.pieModuleRoutePath + "PieChart3",
    //   description: this.chartDescriptions.genericpieChartDescription,
    //   chartFolderPath: this.pieChartModuleComponentPath + "pie-chart3"
    // },
    // {
    //   "imgUrl": this.pieChartImgFolderPath + "04piechart.png",
    //   routePath: this.pieModuleRoutePath + "PieChart4",
    //   description: this.chartDescriptions.genericpieChartDescription,
    //   chartFolderPath: this.pieChartModuleComponentPath + "pie-chart4"
    // },
    // {
    //   "imgUrl": this.pieChartImgFolderPath + "05piechart.png",
    //   routePath: this.pieModuleRoutePath + "PieChart5",
    //   description: this.chartDescriptions.genericpieChartDescription,
    //   chartFolderPath: this.pieChartModuleComponentPath + "pie-chart5"
    // },
    // {
    //   "imgUrl": this.pieChartImgFolderPath + "06piechart.png",
    //   routePath: this.pieModuleRoutePath + "PieChart6",
    //   description: this.chartDescriptions.genericpieChartDescription,
    //   chartFolderPath: this.pieChartModuleComponentPath + "pie-chart6"
    // },
    // {
    //   "imgUrl": this.pieChartImgFolderPath + "07piechart.png",
    //   routePath: this.pieModuleRoutePath + "PieChart7",
    //   description: this.chartDescriptions.genericpieChartDescription,
    //   chartFolderPath: this.pieChartModuleComponentPath + "pie-chart7"
    // },
    // {
    //   "imgUrl": this.pieChartImgFolderPath + "08piechart.png",
    //   routePath: this.pieModuleRoutePath + "PieChart8",
    //   description: this.chartDescriptions.genericpieChartDescription,
    //   chartFolderPath: this.pieChartModuleComponentPath + "pie-chart8"
    // },
    // {
    //   "imgUrl": this.pieChartImgFolderPath + "09piechart.png",
    //   routePath: this.pieModuleRoutePath + "PieChart9",
    //   description: this.chartDescriptions.genericpieChartDescription,
    //   chartFolderPath: this.pieChartModuleComponentPath + "pie-chart9"
    // },
    // {
    //   "imgUrl": this.pieChartImgFolderPath + "10piechart.png",
    //   routePath: this.pieModuleRoutePath + "PieChart10",
    //   description: this.chartDescriptions.genericpieChartDescription,
    //   chartFolderPath: this.pieChartModuleComponentPath + "pie-chart10"
    // },
    {
      "imgUrl": "",
      routePath: this.pieModuleRoutePath + "PieChart1Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.pieChartModuleComponentPath + "piechart11",
      chartFolderPath2: "",
      imgClassName: "pieChart01",
      chartTitle: "01/PIE CHART",
      chartId: 1,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Pie chart"
    },
    {
      "imgUrl": "",
      routePath: this.pieModuleRoutePath + "PieChart2Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.pieChartModuleComponentPath + "piechart12",
      chartFolderPath2: "",
      imgClassName: "pieChart02",
      chartTitle: "02/PIE CHART",
      chartId: 2,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Pie chart"
    },
    {
      "imgUrl": "",
      routePath: this.pieModuleRoutePath + "PieChart3Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.pieChartModuleComponentPath + "piechart13",
      chartFolderPath2: "",
      imgClassName: "pieChart03",
      chartTitle: "03/PIE CHART",
      chartId: 3,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Pie chart"
    },
    {
      "imgUrl": "",
      routePath: this.pieModuleRoutePath + "PieChart4Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.pieChartModuleComponentPath + "piechart14",
      chartFolderPath2: "",
      imgClassName: "pieChart04",
      chartTitle: "04/PIE CHART",
      chartId: 4,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Pie chart"
    },
    {
      "imgUrl": "",
      routePath: this.pieModuleRoutePath + "PieChart5Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.pieChartModuleComponentPath + "piechart15",
      chartFolderPath2: "",
      imgClassName: "pieChart05",
      chartTitle: "05/PIE CHART",
      chartId: 5,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Pie chart"
    },
    {
      "imgUrl": "",
      routePath: this.pieModuleRoutePath + "PieChart6Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.pieChartModuleComponentPath + "piechart16",
      chartFolderPath2: "",
      imgClassName: "pieChart06",
      chartTitle: "06/PIE CHART",
      chartId: 6,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Pie chart"
    },
    {
      "imgUrl": "",
      routePath: this.pieModuleRoutePath + "PieChart7Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.pieChartModuleComponentPath + "piechart17",
      chartFolderPath2: "",
      imgClassName: "pieChart07",
      chartTitle: "07/PIE CHART",
      chartId: 7,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Pie chart"
    },
    {
      "imgUrl": "",
      routePath: this.pieModuleRoutePath + "PieChart8Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.pieChartModuleComponentPath + "piechart18",
      chartFolderPath2: "",
      imgClassName: "pieChart08",
      chartTitle: "08/PIE CHART",
      chartId: 8,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Pie chart"
    },
    {
      "imgUrl": "",
      routePath: this.pieModuleRoutePath + "PieChart9Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.pieChartModuleComponentPath + "piechart19",
      chartFolderPath2: "",
      imgClassName: "pieChart09",
      chartTitle: "09/PIE CHART",
      chartId: 9,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Pie chart"
    },
    {
      "imgUrl": "",
      routePath: this.pieModuleRoutePath + "PieChart10Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.pieChartModuleComponentPath + "piechart20",
      chartFolderPath2: "",
      imgClassName: "pieChart10",
      chartTitle: "10/PIE CHART",
      chartId: 10,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Pie chart"
    },
    // {
    //   "imgUrl": "",
    //   routePath: this.pieModuleRoutePath + "PieChart21",
    //   routePath2: "",
    //   description: [],
    //   chartFolderPath: this.pieChartModuleComponentPath + "piechart21",
    //   chartFolderPath2: "",
    //   imgClassName:"pieChart11",
    //   chartTitle:"11/PIE CHART",
    //   chartId:11,
    //   chartSelectedNumber : 0
    // },
    // {
    //   "imgUrl": '',
    //   routePath: this.pieModuleRoutePath + "PieChart22",
    //   routePath2: "",
    //   description: [],
    //   chartFolderPath: this.pieChartModuleComponentPath + "piechart22",
    //   chartFolderPath2: "",
    //   imgClassName:"pieChart12",
    //   chartTitle:"12/PIE CHART",
    //   chartId:12,
    //   chartSelectedNumber : 0
    // }
  ]

  getChartDescriptions() {
    let genericDescription = [
      "pie color: solid single color, gradient color (linear/radial).",
      "Size of circle can be adjusted according to the plot.",
      "Solid single color, linear gradient color (two variation color), image and text\
      can be provided to the inner circle."
     
    ];
    let chartDescription = {
      genericpieChartDescription: genericDescription
    }
    return chartDescription;
  }

}
